/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

import React, { useEffect, useState } from "react";

import NewsTicker from "../components/news/NewsTicker";
import NewsHero from "../components/news/NewsHero";
import CategorySidebar from "../components/news/CategorySidebar";
import FeaturedNewsGrid from "../components/news/FeaturedNewsGrid";
import NewsFeed from "../components/news/NewsFeed";
import RightSidebar from "../components/news/RightSidebar";

import NAV from "./nav";

import { fetchNews } from "../api";
import PriceScroller from "../components/pricescroll_ver_2";

export default function NewsPage() {

    const [news, setNews] = useState({});
    const [activeCategory, setActiveCategory] = useState("All");

    useEffect(() => {

        fetchNews().then((data) => {
            setNews(data);
        });

    }, []);

    const categories = ["All", ...Object.keys(news)];

    return (

        <div className="
            min-h-screen
            bg-zinc-950
            text-zinc-100
        ">

            {/* Main Navigation */}

            <NAV activetag="news" />
            {/* Market Ribbon */}


            {/* Hero Section */}

            <NewsHero />
                {/*<NewsTicker />*/}
        <PriceScroller/>

            {/* Main Layout */}

            <div className="flex">

                {/* Left Sidebar */}

                <CategorySidebar
                    categories={categories}
                    activeCategory={activeCategory}
                    setActiveCategory={setActiveCategory}
                />

                {/* Main Content */}

                <main className="
                    flex-1
                    px-6
                    py-6
                    min-w-0
                ">

                    <FeaturedNewsGrid news={news} />

                    <NewsFeed
                        news={news}
                        activeCategory={activeCategory}
                    />

                </main>

                {/* Right Sidebar */}

                <RightSidebar />

            </div>

        </div>

    );
}